"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStaticWeb3 = void 0;
var react_1 = require("react");
var web3_1 = __importDefault(require("web3"));
var _LaunchpadProvider_1 = require("../../../LaunchpadProvider");
var connectors_1 = require("../../../shared/hooks/useWeb3/connectors");
var connectors = {};
function useStaticWeb3(chain) {
    var _a;
    var _b = (0, _LaunchpadProvider_1.useLaunchpadProvider)(), chainNodes = _b.chainNodes, chains = _b.chains, defaultChain = _b.defaultChain;
    var chainSymbol = chain || defaultChain.symbol;
    var chainId = (_a = chains.find(function (c) { return chainSymbol === c.symbol; })) === null || _a === void 0 ? void 0 : _a.id;
    var rpcUrl = chainNodes[chainId];
    var _c = (0, react_1.useState)(), web3 = _c[0], setWeb3 = _c[1];
    if (!rpcUrl) {
        throw new Error("No RPC URL for ".concat(chainSymbol, ":").concat(chainId));
    }
    // TODO: provide all urls
    (0, react_1.useMemo)(function () {
        var _a;
        var key = [chainId, rpcUrl].join(",");
        if (!connectors[key]) {
            connectors[key] = (0, connectors_1.createNetworkConnector)(chainId, (_a = {}, _a[chainId] = rpcUrl, _a));
        }
        // @ts-expect-error
        connectors[key].getProvider().then(function (p) { return setWeb3(new web3_1.default(p)); });
    }, [chainId, rpcUrl]);
    return web3;
}
exports.useStaticWeb3 = useStaticWeb3;
